<div class="pageHeaderContainer">
  @if (pageTitle) {
  <div class="pageTitle">
    <h1 [innerHTML]="formattedPageTitle"></h1>
  </div>
  }
</div>
